import { render } from "./BrokerForm.vue?vue&type=template&id=838a128c&scoped=true"
import script from "./BrokerForm.vue?vue&type=script&lang=js"
export * from "./BrokerForm.vue?vue&type=script&lang=js"

import "./BrokerForm.vue?vue&type=style&index=0&id=838a128c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838a128c"]])

export default __exports__